// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__g3pCz","unreadBadge":"styles_unreadBadge__3UonG","modalContent":"styles_modalContent__3dZBO","modal":"styles_modal__2fo78"};